









































import { Vue, Component } from "vue-property-decorator";
import { IIconMenu } from "@/components/shared/types";
const MONTHS = [
  'ม.ค.','ก.ภ.','มี.ค.','เม.ย.','พ.ค.','มิ.ย.','ก.ค.','ส.ค.','ก.ย.','ต.ค.','พ.ย.','ธ.ค.'
];
const CROPS = [
  'cropRice','cropMaize','cropSugarCane','cropCassava'
];
@Component
export default class UserLogin extends Vue {
  crops = CROPS;
  activeCrop: string = CROPS[0];

  get crop() : string[] {
    return [this.activeCrop];
  };
  
  get SelectedApp() : string {
    return this.$store.getters.SelectedApp;
  };

  set SelectedApp(app:string) {
    this.$store.commit('notifyChange', {
      SelectedApp: app
    });
  }

  get Period() : string {
    let today = new Date();
    let yy = today.getFullYear();
    let mm = today.getMonth();
    let dd = today.getDate();
    if (dd<=15) {
      today = new Date(yy, mm, 0);
      yy = today.getFullYear();
      mm = today.getMonth();
      dd = today.getDate();
      return '16-' + dd + ' ' + MONTHS[mm] + ' ' + (yy + 543);
    } else {
      return '01-15 ' + MONTHS[mm] + ' ' + (yy + 543);
    }
  };
}
